import { render, staticRenderFns } from "./show-more-tag.vue?vue&type=template&id=5b0e2f2a&scoped=true&"
import script from "./show-more-tag.vue?vue&type=script&lang=js&"
export * from "./show-more-tag.vue?vue&type=script&lang=js&"
import style0 from "./show-more-tag.vue?vue&type=style&index=0&id=5b0e2f2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e2f2a",
  null
  
)

export default component.exports